import { render } from "./PicnicOutro1View.vue?vue&type=template&id=6b4dc60b&scoped=true"
import script from "./PicnicOutro1View.vue?vue&type=script&lang=js"
export * from "./PicnicOutro1View.vue?vue&type=script&lang=js"

import "./PicnicOutro1View.vue?vue&type=style&index=0&id=6b4dc60b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b4dc60b"]])

export default __exports__